import React from 'react';
import { Helmet } from 'react-helmet';

const LeagueBar = () => (
        <>
            <div className="sef-topbar-widget" />

            <Helmet>
                <script id="league-top-bar-script-loader"
                        data-id="league-top-bar-script"
                        data-src="https://topbar.svenskelitfotboll.se/top-bar-script.min.js"
                        data-allsvenskan="1"
                        data-superettan="0"
                        data-damallsvenskan="0"
                        data-elitettan="0"
                        type="text/javascript"
                        async >{`
                            let sefBarLoaded=false;
                            var leagueTopBarScriptLoader=function(){
                                var s=document.getElementById("league-top-bar-script-loader");
                                var d=new Date;
                                var t="?d="+(d.getFullYear().toString()+d.getMonth().toString()+d.getDate().toString());
                                var l=document.createElement("script");
                                l.id=s.dataset.id;
                                l.src=s.dataset.src+t;
                                l.dataset.allsvenskan=s.dataset.allsvenskan;
                                l.dataset.superettan=s.dataset.superettan;
                                l.dataset.damallsvenskan=s.dataset.damallsvenskan;
                                l.dataset.elitettan=s.dataset.elitettan;
                                l.dataset.timestamp=t;
                                l.type="text/javascript";
                                l.defer=false;
                                l.async=true;
                                var h=document.getElementsByTagName("head")[0];
                                h.appendChild(l)};
                                leagueTopBarScriptLoader();
                `}</script>

            </Helmet>
        </>
    );

export default LeagueBar;
